export default __webpack_public_path__ + "static/media/main3.88380f38.mp4";